module.exports = __webpack_public_path__ + "static/media/hair-testing-banner.4595d7ac.png";